export const months = [
	{ label: 'Jan', value: 'Jan' },
	{ label: 'Feb', value: 'Feb' },
	{ label: 'Mar', value: 'Mar' },
	{ label: 'Apr', value: 'Apr' },
	{ label: 'May', value: 'May' },
	{ label: 'Jun', value: 'Jun' },
	{ label: 'Jul', value: 'Jul' },
	{ label: 'Aug', value: 'Aug' },
	{ label: 'Sep', value: 'Sep' },
	{ label: 'Oct', value: 'Oct' },
	{ label: 'Nov', value: 'Nov' },
	{ label: 'Dec', value: 'Dec' },
];

export const monthMap = {
	january: 0,
	jan: 0,
	1: 0,
	'01': 0,
	february: 1,
	feb: 1,
	2: 1,
	'02': 1,
	march: 2,
	mar: 2,
	3: 2,
	'03': 2,
	april: 3,
	apr: 3,
	4: 3,
	'04': 3,
	may: 4,
	5: 4,
	'05': 4,
	june: 5,
	jun: 5,
	6: 5,
	'06': 5,
	july: 6,
	jul: 6,
	7: 6,
	'07': 6,
	august: 7,
	aug: 7,
	8: 7,
	'08': 7,
	september: 8,
	sep: 8,
	sept: 8,
	9: 8,
	'09': 8,
	october: 9,
	oct: 9,
	10: 9,
	november: 10,
	nov: 10,
	11: 10,
	december: 11,
	dec: 11,
	12: 11,
};

export const days = Array.from({ length: 31 }, (_, i) => ({
	label: String(i + 1).padStart(2, '0'),
	value: String(i + 1),
}));

export const years = Array.from({ length: 100 }, (_, i) => {
	const y = String(new Date().getFullYear() - i);
	return { label: y, value: y };
});
